/*
 * @Author: 王琪瑞
 * @Date: 2021-03-30 16:57:01
 * @LastEditTime: 2021-04-27 11:59:59
 * @LastEditors: 王琪瑞
 */
import {
  reactive, ref, onMounted, SetupContext, computed, watch,
} from 'vue';
import { message, Modal } from 'ant-design-vue';
// import { MessageApi } from 'ant-design-vue/lib/message/index.d';
import { useRoute } from 'vue-router';
import { cloneDeep } from 'lodash';
import axios from '@/axios/api';
import { definitions } from '@/types/api';
import { RoleDataI, CapacityDefault, MaterialDefault } from '../../js/interface';

export interface RoleI {
  roleList: RoleDataI[];

  defaultRoleList: RoleDataI[];

  // capacityDefaultList: CapacityDefault[];

  // roleListMap: Map<string, string>;
}

export class Role implements RoleI {
  roleList: RoleDataI[] = [];

  defaultRoleList: RoleDataI[] = [
    {
      roleName: '财政部',
      imgUrl: '财政部',
      roleImg: require('@/assets/img/department/financial.png'),
    },
    {
      roleName: '公安部',
      imgUrl: '公安部',
      roleImg: require('@/assets/img/department/publicSecurity.png'),
    },
    {
      roleName: '交通部',
      imgUrl: '交通部',
      roleImg: require('@/assets/img/department/traffic.png'),
    },
    {
      roleName: '民政部',
      imgUrl: '民政部',
      roleImg: require('@/assets/img/department/civilAffairs.png'),
    },
    {
      roleName: '人力资源与社会保障部',
      imgUrl: '人力资源与社会保障部',
      roleImg: require('@/assets/img/department/socialSecurity.png'),
    },
    {
      roleName: '卫生部',
      imgUrl: '卫生部',
      roleImg: require('@/assets/img/department/health.png'),
    },
    {
      roleName: '消防部',
      imgUrl: '消防部',
      roleImg: require('@/assets/img/department/firefighting.png'),
    },
    {
      roleName: '新闻部',
      imgUrl: '新闻部',
      roleImg: require('@/assets/img/department/news.png'),
    },
  ];

  // roleListMap: Map<string, string> = new Map();

  constructor(caseId: string) {
    this.roleList = cloneDeep(this.defaultRoleList);
    this.roleList.forEach((e) => {
      Object.assign(e, {
        ...e,
        roleType: 1,
        showStatus: false,
        status: false,
        modelName: '',
        roleSite: '',
        caseId,
        abliltyList: [],
        materialList: [],
        teamList: [],
      });
    });
  }

  async query(caseId: string): Promise<RoleDataI[]> {
    try {
      const { data } = (await axios.queryCustomRoleByCaseId(caseId)).data;

      console.log(data);

      if (data && data.length) {
        const dataMap = new Map();

        data.forEach((e) => {
          dataMap.set(e.roleName, e);
          dataMap.set(e.imgUrl, e);
        });

        this.roleList.forEach((e) => {
          const roleItemObj = dataMap.get(e.imgUrl);
          Object.assign(e, roleItemObj);
        });
      }

      console.log(this.roleList);

      return this.roleList;
    } catch (err) {
      throw new Error(err);
    }
  }
}

export default (context: SetupContext, caseId: string) => {
  const roleModule = reactive(new Role(caseId));

  // const departmentModule = reactive(new Department());

  // route
  const route = useRoute();

  // 案例是否新增或编辑状态
  const isEdit = computed(() => route.query.isEdit === 'edit');

  // 当前编辑部门
  const editDepartmentItem: { item: RoleDataI } = reactive({ item: {} });

  // form
  const editDepartmentForm: { item: RoleDataI } = reactive({ item: {} });

  const formShowStatus = computed(() => (editDepartmentForm.item.showStatus ? 1 : 0));

  const showStatusChange = (value: number) => {
    editDepartmentForm.item.showStatus = value === 1;
  };

  // loading
  const loadings = reactive({
    departmentList: false, // 部门列表
    department: false, // 部门
    departmentDisable: true, // 部门禁用状态
    ablilty: false, // 能力
    team: false, // 队伍
    material: false, // 物资
  });

  // 部门保存准备状态
  const saveStatusCheck = ref(false);

  const changeSaveStatusCheck = (value: boolean) => {
    saveStatusCheck.value = value;
    console.log(saveStatusCheck.value);
  };

  // 默认能力选择项
  const capacityDefaultList: CapacityDefault[] = reactive([
    { capacityName: '队伍数量', value: 0 },
    { capacityName: '物资储备', value: 1 },
    { capacityName: '演练记录', value: 2 },
    { capacityName: '响应速度', value: 3 },
  ]);

  // 默认物资类型选项
  const materialDefaultList: MaterialDefault[] = reactive([
    { materialName: '消防车', valueText: '0' },
    { materialName: '防火服', valueText: '1' },
    { materialName: '医疗包', valueText: '2' },
    { materialName: '资金', valueText: '3' },
    { materialName: '应急食品', valueText: '4' },
    { materialName: '无人机', valueText: '5' },
    { materialName: '棉被', valueText: '6' },
    { materialName: '帐篷', valueText: '7' },
  ]);

  const showText = ref('home');

  const showTextChange = (text: string) => {
    showText.value = text;
  };

  const queryDepartment = async (id = caseId) => {
    try {
      loadings.departmentList = true;
      await roleModule.query(id);
    } catch (err) {
      throw new Error(err);
    } finally {
      loadings.departmentList = false;
    }
  };

  /**
   * 部门 新增/修改 接口
   * @param requestData 部门对象
   * @param status 部门状态
   */
  // const saveDepartment = async (
  //   departmentData: RoleDataI, status = false,
  // ): Promise<definitions['CustomRole']> => {
  //   try {
  //     loadings.department = true;
  //     const requestData = cloneDeep(departmentData);
  //     if (requestData.roleImg) delete requestData.roleImg;
  //     requestData.status = status;
  //     const { data } = (await axios.editCustomRole(requestData)).data;
  //     return data;
  //   } catch (err) {
  //     throw new Error(err);
  //   } finally {
  //     loadings.department = false;
  //   }
  // };

  /**
   * 部门 新增/修改 树状（全量）
   * @param requestData 部门对象
   */
  const saveDepartment = async (
    departmentData: RoleDataI,
  ): Promise<definitions['CustomRole']> => {
    try {
      loadings.department = true;
      const requestData = cloneDeep(departmentData);
      if (requestData.roleImg) delete requestData.roleImg;
      const { data } = (await axios.editTreeCustomRole(requestData)).data;
      return data;
    } catch (err) {
      throw new Error(err);
    } finally {
      loadings.department = false;
    }
  };

  /**
   * 保存部门编辑
   */
  const departmentSave = async () => {
    try {
      if (saveStatusCheck.value) {
        message.error('部门资源存在未保存的数据');
      } else {
        const formData = cloneDeep(editDepartmentForm.item);
        console.log(formData);
        if (formData.teamList) {
          formData.teamList.forEach((e) => {
            if (e.id && e.id.indexOf('VirtualId') !== -1) {
              delete e.id;
            }
          });
        }

        if (formData.materialList) {
          formData.materialList.forEach((e) => {
            if (e.id && e.id.indexOf('VirtualId') !== -1) {
              delete e.id;
            }
          });
        }

        const data = await saveDepartment(formData);

        Object.assign(editDepartmentItem.item, data);

        message.success('保存成功！');
      }
    } catch (err) {
      throw new Error(err);
    }
  };

  /**
   * 切换部门状态
   * @param status 部门状态
   */
  const changeDepartmentStatus = async (status: boolean) => {
    try {
      const formData = cloneDeep(editDepartmentItem.item);
      formData.status = status;
      const data = await saveDepartment(formData);
      Object.assign(editDepartmentItem.item, data);
      editDepartmentForm.item.status = status;
      message.success(status ? '已启用' : '已禁用');
    } catch (err) {
      throw new Error(err);
    }
  };

  /**
   * 增加部门能力
   */
  const addAblilty = () => {
    if (editDepartmentForm.item.abliltyList) {
      editDepartmentForm.item.abliltyList.push({
        caseId,
        roleId: editDepartmentItem.item.id,
        abilityScore: 0,
        abilityType: 0,
        feedback: '',
      });
    }
  };

  /**
   * 删除部门能力
   * @param index 部门能力列表下标
   */
  const delAblilty = async (index: number) => {
    Modal.confirm({
      content: '确认删除？',
      onOk: async () => {
        if (editDepartmentForm.item.abliltyList) {
          const abliltyId = editDepartmentForm.item.abliltyList[index].id;
          if (abliltyId) {
            await axios.delCustomRoleAbility(abliltyId);
          }
          editDepartmentForm.item.abliltyList.splice(index, 1);
        }
      },
    });
  };

  /**
   * 添加队伍
   */
  const addTeam = () => {
    if (editDepartmentForm.item.teamList) {
      editDepartmentForm.item.teamList.push({
        caseId,
        id: `${new Date().getTime().toString()}VirtualId`,
        roleId: editDepartmentItem.item.id,
        arrivalTime: 0,
        peopleQuantity: 0,
        rescueCapability: 0,
        teamName: '',
      });
    }
  };

  /**
   * 暂存队伍
   * @param teamData {id: 队伍id, item: 队伍}
   */
  const saveTeam = (teamData: { id: string; item: definitions['CustomRoleTeam'] }) => {
    Object.assign(
      editDepartmentForm.item.teamList?.filter((item) => teamData.id === item.id)[0],
      teamData.item,
    );
  };

  /**
   * 删除队伍
   * @param teamDelData {id: 队伍id, index: 队伍下标}
   */
  const delTeam = async (teamDelData: { id: string; index: number }) => {
    const { id, index } = teamDelData;
    if (editDepartmentForm.item.teamList) {
      if (id.indexOf('VirtualId') === -1) {
        await axios.delCustomRoleTeam(id);
      }
      editDepartmentForm.item.teamList.splice(index, 1);
    }
  };

  /**
   * 添加物资
   */
  const addMaterial = () => {
    if (editDepartmentForm.item.materialList) {
      editDepartmentForm.item.materialList.push({
        caseId,
        id: `${new Date().getTime().toString()}VirtualId`,
        roleId: editDepartmentItem.item.id,
        materialId: '0',
        quantity: 0,
        responseTime: 0,
        materialName: '',
      });
    }
  };

  /**
   * 暂存物资
   * @param materialData {id: 队伍id, item: 队伍}
   */
  const saveMaterial = (materialData: { id: string; item: definitions['CustomRoleMaterial'] }) => {
    Object.assign(
      editDepartmentForm.item.materialList?.filter((item) => materialData.id === item.id)[0],
      materialData.item,
    );
  };

  /**
   * 删除物资
   * @param materialDelData {id: 队伍id, index: 队伍下标}
   */
  const delMaterial = async (materialDelData: { id: string; index: number }) => {
    const { id, index } = materialDelData;
    if (editDepartmentForm.item.materialList) {
      if (id.indexOf('VirtualId') === -1) {
        await axios.delCustomRoleMaterial(id);
      }
      editDepartmentForm.item.materialList.splice(index, 1);
    }
  };

  /**
   * 显示部门编辑
   * @param item 选择的部门对象
   */
  const showDepartment = async (item: RoleDataI) => {
    try {
      showTextChange('department');

      loadings.department = true;

      editDepartmentItem.item = item;

      if (item.id) {
        const { data } = (await axios.getCustomRoleById(item.id)).data;
        Object.assign(editDepartmentItem.item, data);
      } else {
        const itemData = cloneDeep(item);
        const responseData = await saveDepartment(itemData);
        Object.assign(editDepartmentItem.item, responseData);
      }

      // 初始化部门能力
      if (!editDepartmentItem.item.abliltyList || !editDepartmentItem.item.abliltyList.length) {
        editDepartmentItem.item.abliltyList = [
          {
            caseId,
            roleId: editDepartmentItem.item.id,
            abilityScore: 0,
            abilityType: 0,
            feedback: '',
          },
        ];
      }

      editDepartmentForm.item = {};
      Object.assign(editDepartmentForm.item, cloneDeep(editDepartmentItem.item));

      loadings.departmentDisable = !editDepartmentForm.item.status;
    } catch (err) {
      throw new Error(err);
    } finally {
      loadings.department = false;
    }
  };

  /**
   * 显示民众编辑
   */
  const showPeople = () => {
    showTextChange('people');
  };

  const back = () => {
    // if (JSON.stringify(editDepartmentItem.item) !== JSON.stringify(editDepartmentForm.item)) {
    //   Modal.confirm({
    //     content: '返回后未保存信息将会丢失，是否确认退出？',
    //     onOk: async () => {
    //       showTextChange('home');
    //     },
    //   });
    // } else {
    //   showTextChange('home');
    // }
    Modal.confirm({
      content: '返回后未保存信息将会丢失，是否确认退出？',
      onOk: async () => {
        showTextChange('home');
      },
    });
  };

  const saveStep = () => {
    context.emit('saveStep');
  };

  const nextStep = () => {
    context.emit('nextStep');
  };

  watch(
    () => editDepartmentForm.item.status,
    (status) => {
      loadings.departmentDisable = !status;
    },
    { deep: true, immediate: true },
  );

  onMounted(() => {
    // roleModule.query(caseId);
    queryDepartment();
  });

  return {
    showText,
    roleModule,
    loadings,
    isEdit,
    // departmentModule,
    editDepartmentItem,
    editDepartmentForm,
    formShowStatus,
    capacityDefaultList,
    materialDefaultList,
    saveStatusCheck,
    showStatusChange,
    addAblilty,
    delAblilty,
    addTeam,
    saveTeam,
    delTeam,
    addMaterial,
    saveMaterial,
    delMaterial,
    showTextChange,
    showDepartment,
    showPeople,
    back,
    departmentSave,
    saveStep,
    nextStep,
    saveDepartment,
    // saveDepartmentTree,
    changeDepartmentStatus,
    changeSaveStatusCheck,
  };
};
